export interface BatchReserveContactMailExtractRequest {
  dateFrom: string
  dateTo: string
  userRegistrationBranchCode: string
  receiveBranchCode: string
  isSendContacted: boolean
}

export function BatchReserveContactMailExtractRequestToJSON(
  value: BatchReserveContactMailExtractRequest
): any {
  return {
    date_from: value.dateFrom,
    date_to: value.dateTo,
    user_registration_branch_code: value.userRegistrationBranchCode,
    receive_branch_code: value.receiveBranchCode,
    is_send_contacted: value.isSendContacted
  }
}
